import { Injectable } from '@angular/core';
import {
  CreateQueryResult,
  injectQuery,
} from '@tanstack/angular-query-experimental';
import {
  ApiStatisticsService,
  StatisticsDto,
} from '../api-statistics/api-statistics.service';

@Injectable({
  providedIn: 'root',
})
export class StatisticsQueryService {
  constructor(private readonly apiStatisticsService: ApiStatisticsService) {}

  public queryStatistics(): CreateQueryResult<StatisticsDto, Error> {
    return injectQuery(() => ({
      queryKey: ['statistics'],
      queryFn: () => this.apiStatisticsService.find(),
      throwOnError: false,
    }));
  }
}
